"use client";

import type { DisplayType } from "../../../../lib/types/enums/displayTypeEnum";
import { sectionSchema } from "../../../../lib/types/schema/home/sectionSchema";
import type { UseRequestQueryProps } from "../../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../../request/hooks/useRequestQuery";
import { keyMeRecents } from "./keyMeRecents";

export type UseRequestMeRecentsProps = UseRequestQueryProps & {
  displayType: DisplayType;
};

export const useRequestMeRecents = ({
  displayType,
  ...props
}: UseRequestMeRecentsProps) => ({
  query: useRequestQuery<typeof sectionSchema>({
    queryFnRequestProps: {
      schema: sectionSchema,
      urlBackendPath: `/me/recents${displayType === "sessions" ? "?format=prayer" : ""}`,
    },
    queryKey: keyMeRecents({ displayType }),
    ...props,
  }),
});
